import { ReactComponent as CropCompareIcon } from './crop_compare.svg';

export default CropCompareIcon;
